module.exports = new __parcel__URL__("battlepass_next_page_button_active.67597fd7.png").toString();